<template>
  <div>
    <div class="m-background" :class="['m-background--media-' + getLevel]"></div>
    <Header></Header>
    <div class="l-container l-container--with-header">
        <ChooseLevel />
        <img src="~@/assets/images/rics-logo.png" class="m-logo m-logo--bottom-left" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '../components/header/Header';
import ChooseLevel from '../components/ChooseLevel';

export default {
  components: {
    Header,
    ChooseLevel,
  },
  computed: {
    ...mapGetters(['getLevel']),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ChooseLevel.vue